
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { useMatomo } from '@jonkoops/matomo-tracker-react'
import moment from 'moment'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover';
import Tooltip from 'react-bootstrap/Tooltip'

import React, { Fragment as F, useContext, useEffect, useState } from 'react'
import Modal from 'react-modal'
import Select from 'react-select'
import {
  Link,
} from "react-router-dom"
import { toast } from 'react-toastify'

import {
  appRouter,
  C,
  logg,
  useApiRouter,
} from '$shared'
import {
  AppCtx,
} from '$src/App'
import {
  BanksCtx,
} from '$src/components/banks'
import {
  PeriodsCtx,
} from '$src/components/periods'
import {
  ReportsCtx,
} from '$src/components/reports'
import {
  SchedulesCtx,
} from '$src/components/schedules'

/*
 * SchedulesShowModal
 * single fi report -> view web
**/
const SchedulesShowModal = (props) => {
  // logg(props, 'SchedulesModal')

  /* ctx */

  const {
    selectedResource,
    userConfig,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in SchedulesShowModal')

  const {
    schedulesModalOpen, setSchedulesModalOpen,
    schedulesResults,   setSchedulesResults,
  } = useContext(SchedulesCtx)
  logg(useContext(SchedulesCtx), 'SchedulesCtx in SchedulesShowModal')

  let unformattedPeriods
  if (schedulesResults.length) {
    const tmpUbpr = Object.keys(schedulesResults[0].lineitems)[0]
    if (schedulesResults[0].lineitems[ tmpUbpr ]) {
      unformattedPeriods = Object.keys( schedulesResults[0].lineitems[ tmpUbpr ].values )
    }
  }
  logg(unformattedPeriods, 'unformattedPeriods')
  let li_obj

  return <Modal
    ariaHideApp={false}
    className="SchedulesShowModal BaseModal"
    isOpen={schedulesModalOpen}
    onRequestClose={ () => setSchedulesModalOpen(false) }
    overlayClassName="SchedulesModalOverlay"
  >
    <div className='header'>
      <h5>Single FI Report: { selectedResource.name }</h5>
      <div className='close' onClick={() => setSchedulesModalOpen(false)}>&times;</div>
    </div>
    <div className='modal-content'>

    { schedulesResults.map((bank, idx) => <F key={idx} >
      <ul style={{ listStyleType: 'none', marginTop: '2em', marginLeft: 0, paddingLeft: 0, marginBottom: 0 }} >
        <li>{bank.name}</li>
        <li>{bank.city} - {bank.state}</li>
        <li><b>Cert:</b>{ bank.cert }</li>
      </ul>
      <table className='bordered'>
        <thead>
          <tr>
            <td style={{ minWidth: '250px' }} >&nbsp;</td>
            { unformattedPeriods.map((j, idx) => <td key={idx} >{ moment(j).format(userConfig.dateFormat) }</td> )}
          </tr>
        </thead>
        <tbody>
          { Object.keys(bank.lineitems).map((li, idx) => <tr key={idx} >
            <td>
              { 'H3' === bank.lineitems[li].Schedule_UBPR_Code &&                     <b>{ bank.lineitems[li].Schedule_UBPR_Code_Label }</b> }
              { [ 'BR', 'H3' ].indexOf(bank.lineitems[li].Schedule_UBPR_Code)===-1 && bank.lineitems[li].Reporting_Name }
            </td>
            { Object.keys(bank.lineitems[li].values).map((date, idx) => <td key={idx} >
              { [ 'BR', 'H3' ].indexOf(bank.lineitems[li].Schedule_UBPR_Code)===-1 &&
                  bank.lineitems[li].values[date] || <F>&nbsp;</F> }
            </td> )}
          </tr> )}
        </tbody>
      </table>
    </F> )}

    </div>

    {/* <div className='actions'>
      <div className='left'></div>
      <div className='right'>
      </div>
    </div> */}

  </Modal>
}
export default SchedulesShowModal
